import { RESET_SELECTION } from '../../constants';
import {
    SAVE_RELATIONSHIP_NAME,
    RESET_RELATIONSHIP_NAME,
    INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_SUCCESS,
    SEND_BPS_QUESTION_SUCCESS,
    RESET_SESSIONID,
    RELATIONSHIP_NAMEFIELD_ERROR,
    INITIATE_QUESTIONNAIRE_BUSINESSTYPE,
    UPDATE_TO_PREVIOUS_PAGE,
    PAGE_ACTION_NEXT,
    PAGE_ACTION_BACK,
    SET_BACK_BUTTON_FLAG,
    RESET_BANKER_QUESTIONNAIRE,
} from '../../constants/dynamicLanding';

const initialState = {
    relationshipName: '',
    sessionID: null,
    goBack: null,
    pageAction: PAGE_ACTION_NEXT,
    questionnaire: {
        id: null,
        answers: [],
        metaData: {
            question: null,
            questionType: null,
        },
        currentAnswer: null,
    },
    questionnaireState: [],
    allQuestionaire: [],
    formFields: {},
    fullResponse: {},
    activeQuestionID: '',
    businessTypeState: {},
    dataArchive: {},
    backButtonFlag: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SAVE_RELATIONSHIP_NAME:
            return { ...state, relationshipName: action.payload };
        case RESET_RELATIONSHIP_NAME:
            return { ...state, relationshipName: '' };
        case SET_BACK_BUTTON_FLAG:
            return { ...state, backButtonFlag: action.flag };
        case INITIATE_QUESTIONNAIRE_BUSINESSTYPE: {
            return {
                ...state,
                businessTypeState: {
                    ...action.businessType,
                },
            };
        }
        case INITIATE_QUESTIONNAIRE_DYNAMIC_LANDING_SUCCESS: {
            const currentActiveID = action.payload.activeQuestionID;
            const dataArchive = {
                ...state.dataArchive,
                [currentActiveID]: action.payload.fullResponse,
            };
            return {
                ...state,
                goBack: false,
                sessionID: action.payload.sessionID,
                questionnaire: action.payload.questionnaire,
                activeQuestionID: action.payload.activeQuestionID,
                fullResponse: action.payload.fullResponse,
                allQuestionaire: action.payload.allQuestionaire,
                dataArchive,
            };
        }
        case SEND_BPS_QUESTION_SUCCESS: {
            const currentActiveID = action.payload.activeQuestionID;
            const dataArchive = {
                ...state.dataArchive,
                [currentActiveID]: action.payload.fullResponse,
            };
            const locaQState = state.backButtonFlag
                ? [...state.questionnaireState]
                : [
                      ...state.questionnaireState,
                      action.payload.questionState,
                  ];
            return {
                ...state,
                goBack: false,
                sessionID: action.payload.sessionID,
                questionnaire: action.payload.questionnaire,
                pageAction: PAGE_ACTION_NEXT,
                questionnaireState: locaQState,
                fullResponse: action.payload.fullResponse,
                activeQuestionID: action.payload.activeQuestionID,
                allQuestionaire: action.payload.allQuestionaire,
                businessTypeState: {},
                dataArchive,
            };
        }
        case RESET_SELECTION: {
            return {
                ...state,
                questionnaire: {
                    id: null,
                    answers: [],
                    metaData: {
                        question: null,
                        questionType: null,
                    },
                    currentAnswer: null,
                },
                questionnaireState: [],
                allQuestionaire: [],
                fullResponse: {},
                activeQuestionID: '',
                businessTypeState: {},
                dataArchive: {},
            };
        }
        case RESET_SESSIONID: {
            return {
                ...state,
                sessionID: null,
            };
        }
        case RELATIONSHIP_NAMEFIELD_ERROR: {
            return {
                ...state,
                formFields: action.formFields,
            };
        }
        case UPDATE_TO_PREVIOUS_PAGE: {
            return {
                ...state,
                activeQuestionID: action.activeQuestionID,
                allQuestionaire: action.dataArchive,
                pageAction: PAGE_ACTION_BACK,
            };
        }
        case RESET_BANKER_QUESTIONNAIRE:
            if (!action.isRelNameRequired) {
                return initialState;
            }
            return {
                ...initialState,
                relationshipName: state.relationshipName,
                formFields: !state.relationshipName
                    ? {}
                    : state.formFields,
            };
        default:
            return state;
    }
};
